import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

export const formatSalary = (min, max) => {
  const formatNum = (num) => {
    if (num >= 1000) {
      return `$${(num / 1000).toFixed(0)}k`;
    }
    return `$${num}`;
  };
  
  if (min && max) {
    return `${formatNum(min)} - ${formatNum(max)}`;
  }
  if (min) {
    return `From ${formatNum(min)}`;
  }
  if (max) {
    return `Up to ${formatNum(max)}`;
  }
  return 'Salary not specified';
};

export const getLicenseBadgeClass = (license) => {
  switch (license) {
    case 'LMSW':
      return 'bg-blue-100 text-blue-700';
    case 'LCSW':
      return 'bg-emerald-100 text-emerald-700';
    case 'LBSW':
      return 'bg-purple-100 text-purple-700';
    case 'SWA':
      return 'bg-orange-100 text-orange-700';
    case 'Any':
      return 'bg-gray-100 text-gray-700';
    default:
      return 'bg-amber-100 text-amber-700';
  }
};

export const getStatusBadgeClass = (status) => {
  switch (status) {
    case 'pending':
      return 'bg-amber-100 text-amber-700';
    case 'reviewed':
      return 'bg-blue-100 text-blue-700';
    case 'interview':
      return 'bg-indigo-100 text-indigo-700';
    case 'accepted':
      return 'bg-emerald-100 text-emerald-700';
    case 'rejected':
      return 'bg-red-100 text-red-700';
    case 'active':
      return 'bg-emerald-100 text-emerald-700';
    case 'closed':
      return 'bg-gray-100 text-gray-700';
    case 'draft':
      return 'bg-yellow-100 text-yellow-700';
    default:
      return 'bg-gray-100 text-gray-700';
  }
};

export const jobTypeOptions = [
  { value: 'full-time', label: 'Full Time' },
  { value: 'part-time', label: 'Part Time' },
  { value: 'prn', label: 'PRN' },
  { value: 'contract', label: 'Contract' },
  { value: 'per-diem', label: 'Per Diem' },
  { value: 'temporary', label: 'Temporary' },
];

export const licenseOptions = [
  { value: 'LCSW', label: 'LCSW (Licensed Clinical Social Worker)' },
  { value: 'LMSW', label: 'LMSW (Licensed Master Social Worker)' },
  { value: 'LBSW', label: 'LBSW (Licensed Bachelor Social Worker)' },
  { value: 'SWA', label: 'Social Work Associate' },
  { value: 'Any', label: 'Any License / Entry Level' },
];

export const slugify = (s) =>
  (s || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60);

export const resourceUrl = (r) =>
  `/community-resources/resource/${[slugify(r.name), r.resource_id].filter(Boolean).join('-')}`;

export const resourceIdFromSlug = (slug) => {
  const m = (slug || '').match(/res_[a-z0-9]+$/i);
  return m ? m[0] : slug;
};
